import { useEffect, useState } from 'react';

type orientation = 'portrait' | 'landscape';

export function useScreenOrientation(orientation: orientation) {
  const [doesMatch, setDoesMatch] = useState(false);

  useEffect(() => {
    const query = window.matchMedia(`(orientation: ${orientation})`);
    setDoesMatch(query.matches);

    const handleChange = () => setDoesMatch(query.matches);
    query.addEventListener('change', handleChange);

    return () => query.removeEventListener('change', handleChange);
  }, []);

  return doesMatch;
}
